import { useSelector } from 'react-redux'
import { useAppDispatch } from '@/state'
import { CheckTwoFactorPayload, LoginPayload } from '@/state/auth/models'

import { setTwoFactorStatusAction } from '@/state/auth/slices/index.slices'
import checkTwoFactorThunk from '@/state/auth/thunk/check-two-factor.thunk'
import loginThunk from '@/state/auth/thunk/login.thunks'

import { TwoFactorStatus } from '@/enums/two-factor-status.enum'
import { ApplicationState } from '@/state/root.models'
import { FormValuesLogin } from './schema'

const useLogin = () => {
  const { twoFactorStatus, twoFactorPID } = useSelector(
    ({ auth }: ApplicationState) => auth,
  )

  const dispatch = useAppDispatch()

  /**
   * This function dispatches the request when the user completes all fields
   * @param credentials
   */
  const login = (credentials: LoginPayload) => {
    dispatch(loginThunk(credentials))
  }

  /**
   * This function checks if the 2FA is enabled for the user
   * @param credentials
   */
  const checkTwoFactorAuth = (credentials: CheckTwoFactorPayload) => {
    dispatch(checkTwoFactorThunk(credentials))
  }

  /**
   * This function sets the 2FA Status
   * @param status
   */
  const setTwoFactorStatus = (status: TwoFactorStatus) => {
    dispatch(setTwoFactorStatusAction(status))
  }

  /**
   * This is the function that's executed when all the form inputs are validated
   */
  const handleOnSubmitForm = ({
    email,
    password,
    twoFactorCode,
  }: FormValuesLogin) => {
    const loginPayload: LoginPayload = {
      searchParam: email,
      password,
    }

    if (twoFactorStatus === TwoFactorStatus.INITIAL) {
      login(loginPayload)
    } else {
      if (
        twoFactorStatus === TwoFactorStatus.ACTIVE ||
        twoFactorStatus === TwoFactorStatus.ERROR
      ) {
        const checkPayload = {
          playerId: twoFactorPID,
          code: twoFactorCode,
        }
        checkTwoFactorAuth(checkPayload)
      }
    }
  }

  return {
    twoFactorStatus,
    handleOnSubmitForm,
    setTwoFactorStatus,
  }
}

export default useLogin
